import React from "react";
import { connect } from "react-redux";
import {
  AppleWallet as AppleWalletComponent,
  AppleWalletComponentProps,
} from "../../components/AppleWallet";
import { withAction } from "../Actions/withActions";
import { StoreState } from "../../reducers";
import {
  getAppleWalletError,
  getAppleWalletResponse,
  getIsLoadingAppleWallet,
} from "../../reducers/methods";

class AppleWallet extends React.Component<AppleWalletComponentProps> {
  render() {
    return <AppleWalletComponent {...this.props} />;
  }
}

const mapStateToProps = (state: StoreState) => ({
  appleWalletReferral: getAppleWalletResponse(state),
  isLoading: getIsLoadingAppleWallet(state),
  error: getAppleWalletError(state),
});

export default withAction(connect(mapStateToProps)(AppleWallet));
